import { render, staticRenderFns } from "./chooseOrg.vue?vue&type=template&id=78699914&scoped=true"
import script from "./chooseOrg.vue?vue&type=script&lang=js"
export * from "./chooseOrg.vue?vue&type=script&lang=js"
import style0 from "./chooseOrg.vue?vue&type=style&index=0&id=78699914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78699914",
  null
  
)

export default component.exports